import Create from "./Create";
import Update from "./Update";
import Body from "./Body";

const Components = {
  Create,
  Update,
  Body,
};

export default Components;
